// reactstrap components
import {
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Container,
  Row,
  UncontrolledTooltip,
  Label,
  Form,
  FormGroup,
  Input,
  CardBody,
} from "reactstrap";
import { useState, useEffect } from "react";
// core components
import Header from "components/Headers/Header.js";
import { useHistory } from "react-router-dom";

//data
import {
  ADD_CASH_IN,
  RECEIVED_TRANSACTION_LIST,
  PAYMENT_ACCOUNT_API,
  DELETE_RECEIVED_TRANSACTION,
} from "../../services/CONSTANTS";
import {
  deleteApiDataService,
  getApiDataService,
  postApiDataService,
} from "../../services/apiServices";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { bindNiceSelect } from "utils/NiceSelectUtils";
import "../../utils/NiceSelect.css";
import useDebounce from "./Util/Debounce";
import {
  ConfirmDialog,
  DataTable,
  FilterBar,
  StatusBadge,
  TablePagination,
} from "components/shared";

const COLUMNS = [
  { key: "index", label: "#" },
  { key: "transactionNo", label: "Transaction No" },
  { key: "amount", label: "Amount" },
  { key: "account", label: "Account" },
  { key: "date", label: "Date" },
  { key: "status", label: "Status" },
  { key: "actions", label: "" },
];

const PaymentReceivedTransaction = () => {
  // new NiceSelect(document.getElementById("a-select"), {searchable: true});

  const history = useHistory();
  const [receivedTrasactions, setReceivedTransacrions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const [transactionno, setTransactionno] = useState("");
  const [payment_account_id, setPaymentAccountId] = useState("");
  const [payment_provider_id, setPaymentProviderId] = useState("");
  const [amount, setAmount] = useState("");
  const [search, setSearch] = useState("");
  const debounceSearch = useDebounce(search, 1000);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [item, setitem] = useState(null);
  const [paymentAccounts, setPaymentAccounts] = useState([]);
  const [status, setStatus] = useState("");
  console.log(payment_account_id);

  const [startDate, setStartDate] = useState(
    moment().startOf("day").toISOString()
  );
  const [endDate, setEndDate] = useState(moment().endOf("day").toISOString());

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [meta, setMeta] = useState({});

  useEffect(() => {
    if (paymentAccounts.length > 0) {
      const el = document.getElementById("a-select");
      bindNiceSelect(el);
    }
  }, [paymentAccounts]);

  useEffect(() => {
    fetchPaymentAccounts();
  }, []);

  useEffect(() => {
    fetchTransactions();
  }, [startDate, endDate, payment_account_id,debounceSearch,page,status]);

  let fetchTransactions = () => {
    setIsLoading(true);
    getApiDataService(
      RECEIVED_TRANSACTION_LIST +
        `?start_date=${startDate}&end_date=${endDate}&payment_account_id=${payment_account_id}&search=${search}&page=${page}&per_page=${perPage}&status=${status}`
    )
      .then((res) => {
        console.log("res.data=", res.data);
        setReceivedTransacrions(res.data);
        setIsLoading(false);
        setMeta(res.meta);

      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setIsLoading(false);
        setReceivedTransacrions([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  function debounce(func, delay) {
    let timeoutId;
    return function(...args) {
      const context = this;
      
      clearTimeout(timeoutId);
  
      if (args[0] === "") {
        // If input is cleared, invoke the function immediately
        func.apply(context, args);
        return;
      }
  
      timeoutId = setTimeout(() => func.apply(context, args), delay);
    };
  }

  let fetchPaymentAccounts = () => {
    getApiDataService(PAYMENT_ACCOUNT_API)
      .then((res) => {
        console.log("res.data=", res.data);
        setPaymentAccounts(res.data);
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setPaymentAccounts([]);
      });
    return () => {
      console.log("axios cleanup.");
    };
  };

  let handleExpenseDateChange = (start, end, label) => {
    setStartDate(start.toISOString());
    setEndDate(end.toISOString());
  };

  let chooseDate = (value) => {
    console.log("value",value);
    if(value=="today"){
      setStartDate(moment().startOf("day").toISOString());
      setEndDate(moment().endOf("day").toISOString());
    }
    if(value=="yesterday"){
      setStartDate(moment().subtract(1, 'days').startOf('day').toISOString());
      setEndDate(moment().subtract(1, 'days').endOf('day').toISOString());
    }
    if(value=="this_week"){
      setStartDate(moment().startOf('week').toISOString());
      setEndDate(moment().endOf('week').toISOString());
    }
    if(value=="last_week"){
      setStartDate(moment().subtract(1, 'weeks').startOf('week').toISOString());
      setEndDate(moment().subtract(1, 'weeks').endOf('week').toISOString());
    }
    if(value=="this_month"){
      setStartDate(moment().startOf('month').toISOString());
      setEndDate(moment().endOf('month').toISOString());
    }
  };

  let handleSave = () => {
    let data = {
      transaction_no: transactionno,
      payment_account_id,
      payment_provider_id,
      amount,
    };
    setBtnLoading(true);
    postApiDataService(ADD_CASH_IN, data)
      .then((res) => {
        console.log("res.data=", res.data);
        setBtnLoading(false);
        fetchTransactions();
        setTransactionno("");
        setAmount("");
      })
      .catch((err) => {
        console.log("Error in useEffect!", err);
        setBtnLoading(false);
      });
  };

  const handleDeleteClick = (item) => {
    console.log("Delete item", item);
    setitem(item);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = () => {
    setIsLoading(true);
    console.log("Deleting item", item.id);
    deleteApiDataService(DELETE_RECEIVED_TRANSACTION(item.id))
      .then((res) => {
        console.log("Delete success", res);
        setShowDeleteModal(false);
        fetchTransactions();
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("Error in delete!", err);
      });
  };

  const handleModalBoxCancel = () => {
    setShowDeleteModal(false);
  };
  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col-4">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Add Received Transaction No</h3>
              </CardHeader>
              <CardBody>
                <Form>
                  <FormGroup>
                    <Label for="payment_account_id">Payment Account</Label>
                    <select
                      className="form-control sampleClass"
                      id="a-select"
                      placeholder="Select Payment Account"
                      value={payment_account_id}
                      onChange={(e) => {
                        setPaymentAccountId(e.target.value);
                        setPaymentProviderId(
                          paymentAccounts.find(
                            (item) => item.id == e.target.value
                          ).payment_provider_id
                        );
                      }}
                    >
                      {paymentAccounts.map((item, index) => (
                        //<img src={item.payment_provider.logo}></img>
                        <option key={index} value={item.id}>
                          {item.payment_provider.name} - {item.account_name} (
                          {item.account_no})
                        </option>
                      ))}
                    </select>
                  </FormGroup>

                  <FormGroup>
                    <Label for="amount">Transaction No (Last 6 digit)</Label>
                    <Input
                      type="number"
                      name="amount"
                      id="amount"
                      value={transactionno}
                      onChange={(e) => setTransactionno(e.target.value)}
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="amount">Amount</Label>
                    <Input
                      type="number"
                      name="amount"
                      id="amount"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                  </FormGroup>
                </Form>
              </CardBody>
              <CardFooter className="text-right">
                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={btnLoading}
                >
                  {btnLoading ? "Saving..." : "Save"}
                </button>
              </CardFooter>
            </Card>
          </div>
          <div className="col-8">
            <Card className="shadow">
              <CardHeader className="border-0">
                <FilterBar title="Received Transaction Lists">
                  <Input
                    className="w-auto"
                    type="select"
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    aria-label="Filter by status"
                  >
                    <option value=""> All Status </option>
                    <option value="pending"> Pending </option>
                    <option value="completed"> Completed </option>
                  </Input>
                  <input
                    type="search"
                    style={{ width: "200px" }}
                    className="form-control"
                    placeholder="Search..."
                    aria-label="Search transactions"
                    onChange={(e) => debounce(setSearch(e.target.value), 1000)}
                  />
                  <DateRangePicker onCallback={handleExpenseDateChange}>
                    <input
                      style={{ width: "200px" }}
                      className="form-control"
                      placeholder="Select date range"
                      aria-label="Date range"
                    />
                  </DateRangePicker>
                  <Input
                    className="w-auto"
                    type="select"
                    onChange={(e) => chooseDate(e.target.value)}
                    aria-label="Quick date range"
                  >
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="this_week">This Week</option>
                    <option value="last_week">Last Week</option>
                    <option value="this_month">This Month</option>
                    <option value="last_month">Last Month</option>
                    <option value="this_year">This Year</option>
                  </Input>
                </FilterBar>
              </CardHeader>
              <DataTable
                columns={COLUMNS}
                data={receivedTrasactions}
                isLoading={isLoading}
                emptyMessage="No records found"
                renderRow={(item, index) => (
                  <tr key={item?.id ?? index}>
                    <th>{(meta.page - 1) * meta.perPage + index + 1}</th>
                    <td className="font-mono">{item.transaction_no}</td>
                    <td className="font-mono">{item.amount}</td>
                    <th scope="row">
                      <Media className="align-items-center">
                        <a
                          className=" rounded-circle mr-3"
                          href="#pablo"
                          onClick={(e) => e.preventDefault()}
                        >
                          <img
                            alt="..."
                            src={item?.payment_provider?.logo}
                            style={{ width: "40px" }}
                          />
                        </a>
                        <Media>
                          <span className="mb-0 text-sm">
                            {item?.payment_account?.account_name}
                          </span>
                          <span className="mb-0 text-sm">
                            ( {item?.payment_account?.account_no} )
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td>
                      {moment(item.createdAt).format("DD/MM hh:mm:ss a")}
                    </td>
                    <td>
                      <StatusBadge status={item.status} />
                    </td>
                    <td>
                      {item.status == "pending" && (
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleDeleteClick(item)}
                        >
                          Delete
                        </button>
                      )}
                    </td>
                  </tr>
                )}
              />
              <TablePagination meta={meta} page={page} setPage={setPage} />
            </Card>
          </div>
        </Row>
      </Container>
      {showDeleteModal && (
        <ConfirmDialog
          isOpen
          toggle={handleModalBoxCancel}
          title="Delete"
          message="Are you sure you want to delete this item?"
          confirmText="Yes"
          confirmColor="danger"
          isLoading={isLoading}
          onConfirm={handleDeleteConfirm}
        />
      )}
    </>
  );
};

export default PaymentReceivedTransaction;
